(function MapsAndDirections(global) {
  'use strict';

  const directionsContainer = document.getElementById('nhs_DrivingDirections');
  const mapSection = document.getElementById('nhs_MapsAndDirections');
  const options = {
    rootMargin: '100px 0px'
  };

  /**
   * Initializes the CommuteCalculator module from the NewHomeSource global object.
   */
  function onCommuteCalculatorScriptLoad() {
    global.NewHomeSource.CommuteCalculator.init();
  }

  /**
   * Initializes a Google Maps autocomplete feature and loads a
   * commute calculator script if available.
   */
  function initDrivingDirections() {
    document.body.removeEventListener('googleScriptLoadedAcknowledgement', initDrivingDirections);
    const commuteCalculatorScript = document.querySelector('#CommuteCalculatorBundlejs');
    const addressInput = document.querySelector('#nhsTxtStreeAddress');
    const placeAutocomplete = new google.maps.places.PlaceAutocompleteElement({});
    addressInput.parentNode.insertBefore(placeAutocomplete, addressInput);
    addressInput.type = 'hidden';
    placeAutocomplete.addEventListener('gmp-select', async ({ placePrediction }) => {
      const place = placePrediction.toPlace();
      await place.fetchFields({ fields: ['formattedAddress'] });
      addressInput.value = place.formattedAddress;
    });

    if (commuteCalculatorScript) {
      global.NHS.loadJs(commuteCalculatorScript.value, 'nhs_CommuteCalculatorScript', onCommuteCalculatorScriptLoad);
    }
  }

  /**
  * loadGoogleMapsScript: Load GoogleMapsScript.
  */
  function loadScripts(entries, observer) {
    for (let i = 0; i < entries.length; i += 1) {
      const entry = entries[i];

      if (entry.intersectionRatio > 0 && entry.isIntersecting) {
        document.body.addEventListener('googleScriptLoadedAcknowledgement', initDrivingDirections);
        document.body.dispatchEvent(new CustomEvent('askForGoogleScript'));
        observer.unobserve(mapSection);
      }
    }
  }

  /**
   * trackDrivingDirectionEvent: tracks the click event for the driving direction button.
   * @param {string} drivingDirectionStatus the string with the status value that the driving direction button has.
   */
  function trackDrivingDirectionEvent(drivingDirectionStatus) {
    const googleAnalyticsEvent = {
      eventType: 'GA4Event',
      eventName: 'driving_directions',
      params: {
        click_target: drivingDirectionStatus,
        event_type: 'TDV Events',
        currency: 'USD',
        value: 4
      }
    };
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: { data: googleAnalyticsEvent }
    }));
  }

  if (directionsContainer) {
    directionsContainer.addEventListener('click',
      function (event) {
        if (event.target.id === 'showDrivingDirections' || event.target.closest('#showDrivingDirections')) {
          const elementsToDisplay = document.querySelectorAll('#map_directions,#hideDrivingDirections');
          const drivingDirectionStatusForEvent = 'view driving directions';
          trackDrivingDirectionEvent(drivingDirectionStatusForEvent);

          for (let i = 0; i < elementsToDisplay.length; i++) {
            let element = elementsToDisplay[i];

            element.removeAttribute('hidden');
          }

          const showDirections = document.getElementById('showDrivingDirections');

          if (showDirections) {
            showDirections.setAttribute('hidden', '');
          }
        } else if (event.target.id === 'hideDrivingDirections' || event.target.closest('#hideDrivingDirections')) {
          const elementsToHide = document.querySelectorAll('#map_directions, #hideDrivingDirections');
          const drivingDirectionStatusForEvent = 'hide driving directions';
          trackDrivingDirectionEvent(drivingDirectionStatusForEvent);

          for (let i = 0; i < elementsToHide.length; i++) {
            const element = elementsToHide[i];
            element.setAttribute('hidden', '');
          }

          const showDirections = document.getElementById('showDrivingDirections');

          if (showDirections) {
            showDirections.removeAttribute('hidden');
          }
        }
      });
  }

  const observer = new IntersectionObserver(loadScripts, options);

  if (mapSection) {
    observer.observe(mapSection);
  }

  /**
   * Switches the title for the address section
   * @param {Event} event
   */
  function switchTitle(event) {
    let target = event.target;
    let title = target.dataset.title;

    let titleContainer = document.querySelector('[data-location-title]');

    if (titleContainer && title) {
      titleContainer.textContent = title;
    }
  }

  /**
   * A generic function that can be used to switch between
   * multiple elements, using a data-type attribute
   * @param {Array} elements
   * @param {String} attribute
   */
  function switchElements(elements, attribute) {
    elements.forEach(function (element) {
      if (element.dataset.type === attribute) {
        element.removeAttribute('hidden');
      } else {
        element.setAttribute('hidden', '');
      }
    });
  }

  /**
   * Used to recalculate all routes
   */
  function recalculateRoutes() {
    if (global.NewHomeSource && global.NewHomeSource.CommuteCalculator) {
      global.NewHomeSource.CommuteCalculator.recalculateRoutes();
    }
  }

  /**
   * Switches the active tab
   * @param {Event} event
   */
  function switchActive(event) {
    const currentActive = document.querySelector('[data-map-label][data-active]');
    currentActive.classList.remove('nhs-c-button--tap-light-active');
    currentActive.removeAttribute('data-active');

    const newActive = event.target;
    newActive.classList.add('nhs-c-button--tap-light-active');
    newActive.setAttribute('data-active', '');
  }

  /**
   * Switches the address, in the address section
   * @param {Event} event
   */
  function switchAddress(event) {
    let address = event.target.dataset.type;
    let directions = document.querySelectorAll('[data-map-address]');
    switchElements(directions, address);
  }

  /**
   * Switches the whole content section in the maps and directions section
   * @param {Event} event
   */
  function switchContent(event) {
    let showMap = event.target.dataset.displayMap === 'true';
    let container = document.querySelector('#nhs_PropertyMap');

    if (!showMap) {
      container.setAttribute('hidden', '');
    } else {
      container.removeAttribute('hidden');
    }
  }

  /**
   * Switches between the community and sales office static maps
   * @param {any} event
   */
  function switchStaticMap(event) {
    let type = event.target.dataset.type;
    let maps = document.querySelectorAll('[data-static-map]');

    switchElements(maps, type);
  }

  const salesOfficeTabExists = !!document.querySelector('button[data-type="sales-office"]');

  const builderMapButton = document.querySelector('#builderMap');
  const builderMap = document.querySelector('[data-map="builder"]');

  const labels = document.querySelectorAll('#nhs_MapTabs [data-map-label]');

  labels.forEach(function (label) {
    label.addEventListener('click', function (event) {
      switchActive(event);
      switchContent(event);
      recalculateRoutes();

      if (salesOfficeTabExists) {
        switchTitle(event);
        switchAddress(event);
        switchStaticMap(event);
      }

      if (builderMapButton) {
        if (event.target === builderMapButton) {
          builderMap.removeAttribute('hidden');
        }
        else {
          builderMap.setAttribute('hidden', '');
        }
      }
    });
  });
}(window));
